import { signupTenantOptions } from "../../../../../constants";
import { SIGNUP_INTENT_PARAM, SignupIntent } from "../../../../shared/utils/signupIntent";

/** Region links carry the intent along, since another region's app cannot read this tab's storage. */
const signupTenantOptionsWithIntent = (
  intent: SignupIntent | undefined,
): typeof signupTenantOptions => {
  if (!intent) return signupTenantOptions;
  const withIntent = (url: string) => {
    const target = new URL(url);
    target.searchParams.set(SIGNUP_INTENT_PARAM, intent);
    return target.toString();
  };
  return Object.fromEntries(
    Object.entries(signupTenantOptions).map(([region, option]) => [
      region,
      { ...option, url: withIntent(option.url) },
    ]),
  ) as typeof signupTenantOptions;
};

export default signupTenantOptionsWithIntent;
